/**
 * Loading state for room settings page.
 */
export function RoomSettingsLoadingState() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-primary">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-3 border-accent border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-gray-400">Loading settings...</p>
      </div>
    </div>
  );
}
